
import {  motion } from 'framer-motion'

const bubbleVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.5, ease: 'easeIn' },
  },
}


const UserMessage = ({ children, clientId }) => {
  return (
    <motion.article className="w-full" dir="auto" layout>
      <div className="m-auto pl-[var(--thread-content-margin)] py-5 text-base [--thread-content-margin:--spacing(4)] @[37rem]:[--thread-content-margin:--spacing(6)] @[72rem]:[--thread-content-margin:--spacing(16)]">
        <div
          tabIndex="-1"
          className="mx-auto flex max-w-[var(--thread-content-max-width)] flex-1 gap-4 text-base [--thread-content-max-width:32rem] @[34rem]:[--thread-content-max-width:40rem] @[64rem]:[--thread-content-max-width:48rem] md:gap-5 lg:gap-6"
        >
          <div className="relative flex w-full min-w-0 flex-col">
            <div className="relative flex-col gap-1 md:gap-3">
              <div className="flex max-w-full grow flex-col">
                <div
                  data-message-author-role="user"
                  dir="auto"
                  className="text-message relative flex min-h-8 w-full flex-col items-end gap-2 whitespace-normal break-words text-start [.text-message+&]:mt-5"
                >
                  <div className="flex w-full flex-col items-end gap-1 empty:hidden rtl:items-start">
                    <div className="relative max-w-[var(--user-chat-width,70%)] rounded-3xl bg-accent px-5 py-2.5 text-white/95 backdrop-blur-md text-sm dark:bg-[rgba(255,255,255,0.16)]">
                      <motion.div
                        key={clientId}
                        layout
                        variants={bubbleVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        style={{ willChange: 'transform, opacity' }}
                        className="whitespace-pre-wrap"
                        dir="auto"
                      >
                        {children}
                      </motion.div>
                    </div>
                  </div>
                  <div className="w-16 flex-none" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.article>
  )
}

export { UserMessage }
